import angular from 'angular';
import uiModal from 'angular-ui-bootstrap/src/modal';

import {GradComponent} from './grad.component.js';
import FormComponent from './form/form.js';

const grad = angular.module('grad', [uiModal]);

grad.component('grad', GradComponent);
grad.component('gradForm', FormComponent);

export {grad};



// WEBPACK FOOTER //
// ./app/components/grad/grad.js